/**
 * @file index.tsx
 *
 * @fileoverview Shows information about the organization (about and benefits).
 */
import React, { useContext } from 'react';
import { OrganizationAboutWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/About/Empty';
import { OrganizationAboutWidgetView } from '~/jobiqo/components/Organization/Widgets/About/View';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
const KEY = 'about';

export interface OrganizationAboutWidgetProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
  /**
   * Whether the widget content is trimmed.
   */
  trimmed?: boolean;
  fieldToUpdateId?: string;
  onCancel?: () => void;
}

export const OrganizationAboutWidget = ({
  organization,
  trimmed = false,
}: OrganizationAboutWidgetProps) => {
  const userContext: UserContextInterface = useContext(UserContext);
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const showEmptyWidget = !(
    organization.presentation ||
    organization.size ||
    organization.fieldsOfStudy?.length === 0 ||
    organization.occupation?.length === 0
  );

  if (
    showEmptyWidget &&
    (!organization.contactPersons || organization.contactPersons?.length === 0)
  ) {
    // Empty profile.
    return userContext.user && organization.canEdit ? (
      <OrganizationAboutWidgetEmpty boxId={KEY} organization={organization} />
    ) : null;
  } else {
    return (
      <OrganizationAboutWidgetView
        organization={organization}
        boxId={KEY}
        trimmed={trimmed}
      />
    );
  }
};
export default OrganizationAboutWidget;
